module.exports = "//public.zight.com/packs/media/images/upload-arrow-fc60c304a322460a429b665a7f89f786.svg";